const Brewing = ({ className }) => {
  return (
    <div className={`round-icon ${className}`}>
      <svg
        version="1.1"
        id="Layer_2"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 150 150"
        enableBackground="new 0 0 150 150"
        xmlSpace="preserve"
      >
        <g transform="matrix(-1,0,0,1,150.11019,0)">
          <g>
            <path
              d="M128.05,27.988l-1.83-1c-8.737-4.72-18.116-8.14-27.84-10.15c-0.212-4.34-2.013-8.451-5.06-11.55
			c-3.64-3.61-8.8-5.35-15.28-5.24c-6.649,0.13-11.779,2.07-15.199,5.79c-2.584,2.815-4.105,6.444-4.301,10.26
			c-11.994,1.818-23.629,5.496-34.49,10.9l0.061,1v18.1c-1.303-0.556-4.578-0.894-5.99-1c-4.33-0.33-8.539,1.53-12.529,5.51
			l-2.471,2.47l4.939,4.94l2.461-2.47c2.471-2.47,4.83-3.64,7-3.49c1.785,0.22,5.348,1.05,6.59,2.35v5.06c0,20.37,0,18.653,0,38.37
			c0,19.715,0,27,0,45.9v6.219h103.94 M67.9,10.588c2.13-2.27,5.58-3.47,10.261-3.56c5.52-0.09,9.409,1.49,11.529,4.74
			c0.698,1.087,1.199,2.289,1.48,3.55v0.25c-8.482-1.129-17.067-1.264-25.58-0.4C65.915,13.455,66.716,11.868,67.9,10.588z
			 M119.823,142.719l-87.873,0.119c0-18,0-22.756,0-45c0-27,0-9,0-36v-27c9.1-4.26,46.563-23.86,87.873-2.66V142.719z"
            />
          </g>
        </g>
        <path
          d="M22.09,54.213c-1.242-1.3-2.896-2.13-4.68-2.35c-2.17-0.15-4.53,1.02-7,3.49l-2.461,2.47l-4.939-4.94l2.47-2.47
	c3.99-3.98,8.2-5.84,12.53-5.51c1.412,0.106,2.797,0.444,4.1,1"
        />
      </svg>
    </div>
  );
};

export default Brewing;
